import { render, staticRenderFns } from "./WorkIconPriceUpload.vue?vue&type=template&id=f5418f04"
import script from "./WorkIconPriceUpload.vue?vue&type=script&lang=js"
export * from "./WorkIconPriceUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports